import { render, staticRenderFns } from "./MorphologyPopup.vue?vue&type=template&id=ffa28500&scoped=true&"
import script from "./MorphologyPopup.vue?vue&type=script&lang=js&"
export * from "./MorphologyPopup.vue?vue&type=script&lang=js&"
import style0 from "./MorphologyPopup.vue?vue&type=style&index=0&id=ffa28500&prod&lang=scss&"
import style1 from "./MorphologyPopup.vue?vue&type=style&index=1&id=ffa28500&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa28500",
  null
  
)

export default component.exports